var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-container"},[_c('Sidebar'),_c('div',{staticClass:"main-container",class:[_vm.isCollapse ? 'isCollapse' : '']},[_c('Navbar'),_c('TagsView'),_c('AppMain')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }